export class WalletError extends Error {
  constructor(public readonly i18nKey: string) {
    super(i18nKey);
    this.name = new.target.name;
  }
}

export class InvalidQrCodeError extends WalletError {
  constructor() {
    super('fv_snackbar.wallet.invalid_qr_msg');
  }
}

export class ScanTimeoutError extends WalletError {
  constructor() {
    super('fv_snackbar.wallet.scan_timeout_title');
  }
}

export class WalletNotFoundError extends WalletError {
  constructor() {
    super('fv_snackbar.wallet.scan_error_msg');
  }
}

export class WalletGenericError extends WalletError {
  constructor() {
    super('fv_snackbar.wallet.scan_error_title');
  }
}
